import { useMemo } from 'react';

import { useConfigurationStore } from 'store/configurationsStore';

import { QueryResponse as ComponentListApiResponse } from 'api/queries/getComponentLiteList';

import { IHashmap } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';

export const useComponentListOptions = (componentList: ComponentListApiResponse[] | undefined) => {
    const configuration = useConfigurationStore();
    return useMemo<ISelectOption<string>[]>(
        () =>
            componentList
                ? componentList
                      .filter((item) => {
                          const widgetConfigInReport = item.componentKey
                              ? configuration[item.componentKey as keyof IHashmap]
                              : undefined;
                          return widgetConfigInReport?.componentMenu?.useAutomatedNarrative;
                      })
                      .map((item) => ({
                          label: item.name,
                          value: item.componentKey,
                          id: item.id,
                      }))
                      .sort((a, b) => a.label.localeCompare(b.label))
                : [],
        [componentList, configuration],
    );
};
